import { render, staticRenderFns } from "./textarea-field.vue?vue&type=template&id=2bf4a9ac&scoped=true&lang=pug"
import script from "./textarea-field.vue?vue&type=script&lang=js"
export * from "./textarea-field.vue?vue&type=script&lang=js"
import style0 from "./textarea-field.vue?vue&type=style&index=0&id=2bf4a9ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4a9ac",
  null
  
)

export default component.exports